const objectivesData = [
    {
        id:"1",
        title:"Objectives",
        details:"MA Partners will not allow bias, conflict of interest or undue influence of others to override its professional or business judgments."
    },
    {
        id:"2",
        title:"Professional Competence ",
        details:"MA Partners maintains professional knowledge and skill at the level required to ensure that clients receive competent professional services.."
    },
    {
        id:"3",
        title:"Integrity",
        details:"MA Partners will be straightforward and honest in all professional and business relationships."
    },
    {
        id:"4",
        title:"Confidentiality",
        details:"MA Partners will respect the confidentiality of information acquired as a result of professional and business relationships and there-fore, do not disclose any such information to third parties."
    },

]

export default objectivesData;